import axios from 'axios';

import history from './history';
import config from '../config';

import UserAPI from './UserAPI';

const apiPath = config.api.proposals;

function url(...rest) {
  return rest.map(val => `${val}`.replace(/\/$/, '')).join('/');
}

class ProposalAPI {
  static search(searchParams) {
    return axios({
      method: 'get',
      url: apiPath,
      params: searchParams,
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static get(proposalId) {
    return axios({
      method: 'get',
      url: url(apiPath, proposalId),
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static post(data) {
    return axios({
      method: 'post',
      url: apiPath,
      data,
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static put(proposalId, data) {
    return axios({
      method: 'put',
      url: url(apiPath, proposalId),
      data,
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static delete(proposalId) {
    return axios({
      method: 'delete',
      url: url(apiPath, proposalId),
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static submit(proposalId) {
    return axios({
      method: 'post',
      url: url(apiPath, proposalId, 'submit'),
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }
}

export default ProposalAPI;
